import { IIconProps } from '../../types/IconProps.interface'

export const IconAi = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M6.43679 5.84595C6.82202 4.71797 8.41722 4.71803 8.80251 5.84595L9.96706 9.25537C10.0921 9.6215 10.3798 9.90908 10.7459 10.0342L14.1553 11.1987C15.2834 11.5839 15.2834 13.1792 14.1553 13.5645L10.7459 14.729L10.6128 14.7827C10.3105 14.9265 10.0766 15.1872 9.96706 15.5078L8.80251 18.9172L8.71706 19.1162C8.25586 19.9797 6.98344 19.9797 6.52224 19.1162L6.43679 18.9172L5.27224 15.5078C5.16271 15.1873 4.9288 14.9265 4.62649 14.7827L4.49343 14.729L1.08401 13.5645C0.0266985 13.2033 -0.0400263 11.7784 0.885031 11.2842L1.08401 11.1987L4.49343 10.0342C4.81405 9.92467 5.07474 9.69078 5.21853 9.38843L5.27224 9.25537L6.43679 5.84595Z'
        fill={color}
        fillRule='evenodd'
      />
      <path
        d='M17.5 5.625C17.8452 5.625 18.125 5.90482 18.125 6.25V7.5H19.375C19.7202 7.5 20 7.77982 20 8.125C20 8.47018 19.7202 8.75 19.375 8.75H18.125V10C18.125 10.3452 17.8452 10.625 17.5 10.625C17.155 10.6248 16.875 10.3451 16.875 10V8.75H15.625C15.28 8.74979 15 8.47005 15 8.125C15 7.77995 15.28 7.50021 15.625 7.5H16.875V6.25C16.875 5.90495 17.155 5.6252 17.5 5.625Z'
        fill={color}
      />
      <path
        d='M13.125 0C13.4702 0 13.75 0.279822 13.75 0.625V2.5H15.625C15.9702 2.5 16.25 2.77982 16.25 3.125C16.25 3.47018 15.9702 3.75 15.625 3.75H13.75V5.625C13.75 5.97018 13.4702 6.25 13.125 6.25C12.78 6.24979 12.5 5.97005 12.5 5.625V3.75H10.625C10.28 3.74979 10 3.47005 10 3.125C10 2.77995 10.28 2.50021 10.625 2.5H12.5V0.625C12.5 0.279949 12.78 0.000205105 13.125 0Z'
        fill={color}
      />
    </svg>
  )
}
